<script>
import { mapGetters, mapMutations } from "vuex";
import PrevNextNavButtons from "@/components/PrevNextNavButtons"
import CostService from "@/store/services/cost.service.js"

export default {
  name: 'PrevNextNavCosts',
  extends: PrevNextNavButtons,
  data () {
    return {
      saveNav: false
    }
  },
  computed: {
    ...mapGetters({ 
      cost: 'costs/getCost',
      tempItemList: 'costs/getTempCostList',
      initialNext: 'costs/getTempCostListNext',
      isControlPanel: "main/isControlPanel"
    }),
  },
  created () {
    this.checkPrevNext()
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'costs/SET_TEMP_COST_LIST') {
        this.checkPrevNext()
      }
    })
  },
  destroyed () {
    this.unsubscribe()
  },
  methods: {
    ...mapMutations({ 
      setTempItemList: "costs/SET_TEMP_COST_LIST",
    }),

    async getMoreItems (recurring = false) {
      // need next tick to wait for initialNext mutation
      this.$nextTick(() => {
        if ((this.initialNext && !this.useCurrentNext) || (this.currentNext && this.useCurrentNext)) {
          if(!this.currentNext) this.currentNext = this.initialNext
          return CostService.loadNextPage(this.currentNext).then((response) => {
            if (response.data.results) {
              this.useCurrentNext = true
              this.currentNext = response.data.next
              this.setTempItemList(this.tempItemList.concat(response.data.results));
              if (recurring) this.checkPrevNext()
            }
          })
        }
      })
    },
    async navigateTo (target_id, direction, save = false) {
      if (target_id) {
        if (save) await this.saveAndNavigate(target_id)
        if(!save || this.saveNav) {
          if (this.$route.path.includes('control-panel')) {
            this.$emit('navigateTo', target_id)
          } else {
            this.navigating = direction
            this.$emit('nav-direction', this.navigating)
            this.$router.push({ name: !this.isControlPanel ? 'EditCost' : 'ControlPanelEditCost', params: { costId: target_id } }).catch(() => {})
          }
        }

      }
    },
    async saveAndNavigate () {
      this.saveNav = true
      for (var propName in this.cost) {
        if (this.cost[propName] === null || this.cost[propName] === undefined) {
          delete this.cost[propName];
        }
      }
      if (this.cost.cost_lines.length === 0) {
        delete this.cost.cost_lines;
      }
      // TODO move to store
      var cost = CostService.prepareCostForUpload(this.cost);
      return CostService.update(cost.id, cost).then( (response) => {
        this.cost.image = response.data.image

        this.$store.commit('setAlert', {
          title: this.$gettext('Cost Updated'),
          text: this.$gettext('Successfully edited cost'),
          variant: 'success',
          duration: 4
        })

        this.$emit('cost-edit-nav', false)

      }).catch( (response) => {
        // TODO move to store
        // this.saveError(response)
        this.saveNav = false
        if(response && response.non_field_errors && response.non_field_errors[0] === 'The fields number, owner_company must make a unique set.') {
          this.$store.commit('setAlert', {title: this.$gettext("Error"), text:this.$gettext("Cost not saved, cost number already in use."), variant:"danger",duration:4});
        } else {
          this.$store.commit('setAlert', {title: this.$gettext("Error"), text:this.$gettext("Something went wrong, cost is not saved."), variant:"danger",duration:4});
        }
      })
    },
  }
}
</script>
